import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import Loader from "../../Components/Loader";
import HsCodeAdditionalService from "../../Services/HsCodeAdditionalService";

export const EditHsCodeAdditionalFees = ({ item, setShow, getData }) => {
  const [loader, setLoader] = useState(false);
  const history = useHistory();

  const initialValues = {
    additional_charge: "",
  };

  const validationSchema = Yup.object().shape({
    additional_charge: Yup.string().required("Required"),
  });

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setLoader(true);
      values = { ...values, id: item._id };
      HsCodeAdditionalService.updateHscodeadditionalfees(values).then((res) => {
        if (res.status) {
          toast.success(res.msg);
          setLoader(false);
          setShow(false);
          getData();
        } else {
          setLoader(false);
          toast.error(res.message);
        }
      });
    },
  });

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
    getFieldProps,
  } = formik;

  useEffect(() => {
    if (item?.additional_charge) {
      setFieldValue("additional_charge", item.additional_charge);
    }
  }, [item]);

  console.log(item, "item")

  return (
    <div className="row d-flex justify-content-center">
      <form className="control-form" autoComplete="off" onSubmit={handleSubmit}>
        {/* Charges  */}
        <div className="row">
          <div className="mb-3 col-12">
            <label className="form-label">Additional Charge</label>
            <input
              type="number"
              className={
                "form-control" +
                (touched.additional_charge && errors.additional_charge
                  ? " is-invalid"
                  : "")
              }
              value={values?.additional_charge}
              name="additional_charge"
              placeholder="Enter Additional Charge"
              {...getFieldProps("additional_charge")}
            />
            {touched.additional_charge && errors.additional_charge ? (
              <div className="text-danger">{errors.additional_charge}</div>
            ) : null}
          </div>
        </div>

        <div className="mt-3 d-flex justify-content-between">
          <button
            className="btn btn-danger w-sm waves-effect waves-light"
            type="button"
            onClick={() => setShow(false)}
          >
            Back
          </button>
          <button
            className="btn btn-primary w-sm waves-effect waves-light"
            type="submit"
          >
            Submit
          </button>
        </div>
      </form>
      <Loader isShow={loader} />
    </div>
  );
};
